export default __webpack_public_path__ + "static/media/automovelAutoValorSmall.230a4f4e.png";